import _styled, { default as _styled2 } from "styled-components";
import React, { type RefObject } from "react";
import { type HTMLMotionProps, m } from "framer-motion";
import { type Shape } from "~/features/ui/slider";
type Props = {
  sliderInstance: RefObject<Shape | null>;
  isFilled?: boolean;
  orientation: "horizontal" | "vertical";
};
export function AutoplayProgress(props: Props & HTMLMotionProps<"div">) {
  const {
    sliderInstance,
    orientation,
    isFilled,
    ...rest
  } = props;
  const thumbRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!sliderInstance.current?.splide || !thumbRef.current) {
      return;
    }
    if (isFilled) {
      if (orientation === "horizontal") {
        thumbRef.current.style.transform = `scaleX(1)`;
      } else {
        thumbRef.current.style.transform = `scaleY(1)`;
      }
      return;
    }
    sliderInstance.current.splide.on("autoplay:playing", (rate: number) => {
      if (!thumbRef.current) return;
      if (orientation === "horizontal") {
        thumbRef.current.style.transform = `scaleX(${rate})`;
      } else {
        thumbRef.current.style.transform = `scaleY(${rate})`;
      }
    });
  }, [orientation, sliderInstance, isFilled]);
  return <_StyledMDiv initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} {...rest}>
      <_StyledDiv ref={thumbRef} style={{
      transform: orientation === "horizontal" ? "scaleX(0)" : "scaleY(0)"
    }} $_css={[{
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
    }, orientation === "horizontal" ? {
      "height": "0.1rem",
      "width": "100%",
      "transformOrigin": "left"
    } : {
      "height": "100%",
      "width": "0.1rem",
      "transformOrigin": "top"
    }]} />
    </_StyledMDiv>;
}
var _StyledMDiv = _styled(m.div).withConfig({
  componentId: "sc-sf-1elivth-0"
})({
  "backgroundColor": "rgb(75 46 248 / 0.2)"
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "autoplay-progress___StyledDiv",
  componentId: "sc-8d12iy-0"
})(["", ""], p => p.$_css);